import _objectSpread from "@babel/runtime/helpers/esm/objectSpread";
import "core-js/modules/web.dom.iterable";
// eslint-disable-next-line
import { InMemoryCache, IntrospectionFragmentMatcher } from 'apollo-cache-inmemory';
import schema from './apollo-schema.json';
const fragmentMatcher = new IntrospectionFragmentMatcher({
  introspectionQueryResultData: schema
});
export default function (_ref) {
  let {
    store,
    req
  } = _ref;
  const {
    header = {}
  } = req || {};
  const {
    graphqlExternal,
    graphqlInternal
  } = store.getters['sharedEnv/getSharedEnv'];
  const xMdM = Object.entries(header).filter((_ref2) => {
    let [key] = _ref2;
    return /^x-mdm-/i.test(key);
  }).reduce((acc, _ref3) => {
    let [key, value] = _ref3;
    acc[key] = value;
    return acc;
  }, {});
  return {
    httpEndpoint: process.browser ? graphqlExternal : graphqlInternal,
    httpLinkOptions: {
      headers: _objectSpread({}, xMdM, header['correlation-id'] && {
        'correlation-id': header['correlation-id']
      }, header['mdm-client-ip'] && {
        'mdm-client-ip': header['mdm-client-ip']
      })
    },
    cache: new InMemoryCache({
      fragmentMatcher
    })
  };
}